import { houseApi } from '../../../../../apis/houseApi';

export function handleSearch(trackingSysId, houseNum, setIsLoading, setOptions, setErrorData) {
  setIsLoading(true);
  setErrorData({ status: null, messages: null });

  houseApi.getHouseItems(trackingSysId, houseNum)
    .then(( items ) => {
      if(items.length !== 0){
        setOptions(items);
      }
      setIsLoading(false);
    })
    .catch((error) => {
      console.error("Ocorreu um erro ao buscar as houses:", error);

      setErrorData({
        status: error.response.status,
        messages: error.response.data
      });
    });
};

export function handleKeyDown(event, trackingSysId, setIsLoading, setOptions, setErrorData) {
   if (event.key === 'Enter') {
       handleSearch(trackingSysId, event.target.value, setIsLoading, setOptions, setErrorData);
    }
};

export function searchHouse (intl, trackingSysId, setHouse, inputValue, onDataReceived, setErrorData, setWarnData) {  
  setErrorData({ status: null, messages: null });
  if(Array.isArray(inputValue) && inputValue.length) {
    setHouse(inputValue[0]);
    onDataReceived("Loading");

    houseApi.getHouseByNum(trackingSysId, inputValue[0].houseId)
      .then((Data) => {
        Data.fields = Data.fields.sort((field, nextField) => field.priority - nextField.priority);
        onDataReceived({...Data, houseNum: inputValue[0].houseNum});
      })
      .catch((error) => {
        console.error("Ocorreu um erro ao buscar o formulário:", error);

        setErrorData({
          status: error.response.status,
          messages: error.response.data
        });
      });
  }
  else{
    setWarnData([intl.messages.searchAndSelectHouseNo]);
  } 
};